import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColorPipeService {
  transform(hex: string): string {
    if (!hex.includes('#')) {
      return hex;
    }

    let _hex = hex.replaceAll('#', '');

    while (_hex.length < 5) {
      _hex += _hex;
    }

    _hex = _hex.substring(0, 6);

    return `#${_hex}`;
  }
}
